import type { HostedBusinessOwner } from '@onefootprint/request-types';
import type { ManageBosFormData } from '../manage-business-owners.types';

const getFilteredExistingOwners = (existingOwners: HostedBusinessOwner[], bosToDelete: string[]) =>
  existingOwners.filter(bo => !bosToDelete.includes(bo.uuid));

const hasDuplicates = (values: (string | undefined)[]): boolean => {
  const filtered = values.filter(Boolean);
  return filtered.length > 0 && new Set(filtered).size !== filtered.length;
};

const normalizePhoneNumber = (phone?: string): string => {
  if (!phone) return '';
  return phone.replace(/\D/g, '').replace(/^0+/, '');
};

export const sumTotalOwnershipStake = (
  existingOwners: HostedBusinessOwner[],
  { bos, bosToDelete }: ManageBosFormData,
): number => {
  const filtered = getFilteredExistingOwners(existingOwners, bosToDelete);
  const allOwners = [...filtered.filter(owner => !bos.some(bo => bo.uuid === owner.uuid)), ...bos];
  return allOwners.reduce((sum, bo) => sum + (bo.ownershipStake ?? 0), 0);
};

export const hasDuplicatedEmail = (
  existingOwners: HostedBusinessOwner[],
  { bos, bosToDelete }: ManageBosFormData,
): boolean => {
  const filtered = getFilteredExistingOwners(existingOwners, bosToDelete);
  const existingEmails = filtered
    .filter(owner => !bos.some(bo => bo.uuid === owner.uuid))
    .map(owner => owner.decryptedData['id.email']);
  const newEmails = bos.map(owner => owner.email);
  return hasDuplicates([...existingEmails, ...newEmails]);
};

export const hasDuplicatedPhoneNumber = (
  existingOwners: HostedBusinessOwner[],
  { bos, bosToDelete }: ManageBosFormData,
): boolean => {
  const filtered = getFilteredExistingOwners(existingOwners, bosToDelete);
  const existingPhones = filtered
    .filter(owner => !bos.some(bo => bo.uuid === owner.uuid))
    .map(owner => normalizePhoneNumber(owner.decryptedData['id.phone_number']));
  const newPhones = bos.map(owner => normalizePhoneNumber(owner.phoneNumber));
  return hasDuplicates([...existingPhones, ...newPhones]);
};
